module.exports = __webpack_public_path__ + "static/img/ic_bottom_map_on@2x.924c37e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/ic_bottom_map_on@2x.png
// module id = O3rT
// module chunks = 1